import React from 'react';
import { useTranslation, Trans } from 'next-i18next';
import MarketingSection from 'src/components/MarketingSection';
import ChartWithDescription from './components/ChartWithDescription';
import styles from './styles.module.scss';
import { useRouter } from 'src/shared/hooks';
import RoutePaths from 'src/config/RoutePaths';
import { fireGA } from 'src/utils/gaUtils';

const ChartSection = () => {
    const { t } = useTranslation();
    const router = useRouter();

    const clickInsights = () => {
        fireGA('marketingQ421', 'clickSeeMarketInsights', 'See market insights');
        router.pushPath(RoutePaths.INSIGHTS);
    };

    const clickRegister = () => {
        fireGA('marketingQ421', 'clickSignUp', 'Why PM');
        router.pushPath(RoutePaths.REGISTER);
    };

    return (
        <MarketingSection containerClassName={styles.container}>
            <ChartWithDescription
                title={t('private_market_chart_title_1')}
                description={<Trans i18nKey="private_market_chart_description_1" />}
                buttonText={t('see_market_insights_button')}
                type="rightChart"
                chartSrc="/static/images/img_graph1@2x.jpg"
                onClick={clickInsights}
            />
            <ChartWithDescription
                title={t('private_market_chart_title_2')}
                description={<Trans i18nKey="private_market_chart_description_2" />}
                buttonText={t('sign_up_to_view_products')}
                type="leftChart"
                chartSrc="/static/images/img_graph2@2x.jpg"
                onClick={clickRegister}
            />
        </MarketingSection>
    );
};

export default ChartSection;
